<template>
    <div class="EventManagement">
        <div class="p-title">事件管理</div>
        <div class="title">事件统计</div>
        <div class="row-center land">
            <div class="pie">
                <PieCharts :pieData="pieData" :total="total" :width="'160rem'" :height="'200rem'"></PieCharts>
            </div>
            <div class="panelright row-center" style="justify-content: space-between;">
                <div class="item column-center">
                    <div class="name">紧急</div>
                    <div class="num" style="color:#FF5555">{{eventInfo.urgent}}</div>
                </div>
                <div class="item column-center">
                    <div class="name">隐患</div>
                    <div class="num" style="color:#F5AA00">{{eventInfo.hiddenDanger}}</div>
                </div>
                <div class="item column-center">
                    <div class="name">通知</div>
                    <div class="num" style="color:#0D94FF">{{eventInfo.notice}}</div>
                </div>
            </div>
        </div>
        <div class="title">历史事件</div>
        <div class="eventPage">
            <div class="search column-center">
                <div class="block">
                    <el-date-picker
                        v-model="timeOption"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="-"
                        start-placeholder="开始日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        end-placeholder="结束日期"
                        style="width:330px"
                        align="right">
                    </el-date-picker>
                </div>
                <div class="block">
                    <el-dropdown click="dropdown"  trigger="click">
                        <el-button >
                            事件等级<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" class="dropdownList">
                            <el-checkbox label="全部" class="all" v-model="ClassAll" @change="changeClassAll"></el-checkbox>
                            <el-checkbox-group v-model="checkValue" class="checkbox"  @change="handleCheckedCitiesChange">
                                <el-checkbox :label="item.value" :value="item.value" v-for="item in checkList">{{item.label}}</el-checkbox>
                                <!-- <el-checkbox label="紧急" value="URGENT" ></el-checkbox>
                                <el-checkbox label="隐患" value="HIDDEN_DANGER"></el-checkbox>
                                <el-checkbox label="通知" value="NOTICE"></el-checkbox> -->
                            </el-checkbox-group>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="block">
                    <el-dropdown click="dropdown"  trigger="click">
                        <el-button >
                            全部<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" class="dropdownList">
                            <el-checkbox label="全部" class="all" v-model="readCheckAll" @change="changeReadCheckAll"></el-checkbox>
                            <el-checkbox-group v-model="readCheck" class="checkbox" @change="handleReadCheck">
                                <el-checkbox label="0" value="0">未解决</el-checkbox>
                                <el-checkbox label="1" value="1">已解决</el-checkbox>
                            </el-checkbox-group>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="block">
                    <el-select v-model="identTypeClass" placeholder="请选择" 
                        style="width:120px">
                        <el-option
                        v-for="item in TYPE"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-dropdown click="dropdown"  trigger="click">
                        <el-button >
                            事件类型<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" class="dropdownList">
                            <el-checkbox label="全部" class="all"></el-checkbox>
                            <el-checkbox-group v-model="checkList" class="checkbox">
                                <el-checkbox label="已解决"></el-checkbox>
                                <el-checkbox label="未解决"></el-checkbox>
                            </el-checkbox-group>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                </div>
            </div>
            <div >
                <!-- v-loading="loading" -->
                <div style="height:500px" v-if="loading">
                    <Loading LoadingId="EventManagementShowLoading" :scale="0.6"   />
                </div>
                <div class="page" id="page"  v-if="!ishow"  >
                    <div class="cont" v-for="(item,index) in eventList" :key="index" :class="{show:item.check}"  >
                        <div class="header"  @click="checkArrow(item,index)" :class="{yell:item.level=='hiddenDanger',notice:item.level=='notice'}">
                            <div class="type row-center" ><img src="@/assets/img/alarm.png" alt="">
                            <i>{{item.levelText}}</i>
                            <div class="point" v-if="item.readCheck==0"></div>
                            </div>
                            <div class="name-r column-center">
                                <div class="left">
                                    <div class="name">{{item.eventName}}</div>
                                    <div class="text"><i v-if="item.loopName">{{item.loopName}}</i><i v-else>{{item.deviceName}}</i><i v-if="item.judgmentMode=='Threshold_Value'"> {{item.conditionJudgmentText}}</i>-{{item.eventName}}</div>
                                </div>
                                <div class="time row-center">
                                    <div>
                                        <div>发生时间：{{dateFormat('YYYY年mm月dd日 HH:MM', new Date(item.startTime))}}</div>
                                        <div>结束时间：<span v-if="item.endTime">{{dateFormat('YYYY年mm月dd日 HH:MM', new Date(item.endTime))}}</span><span v-else style="color:#FF5555">未解决</span></div>
                                    </div>
                                    <div class="arrow"><i class="el-icon-arrow-right"></i></div>
                                </div>
                            </div>
                        </div>
                        <div class="info row-center">
                            <div class="description" style="width:50%">
                                <div class="data-title">基本信息</div>
                                <div class="description-content">
                                    <div>事件分类：{{item.eventClassText}}</div>
                                    <div>站点信息：{{item.areaName}}</div>
                                    <div>告警设备：{{item.deviceName}}</div>
                                    <div>发生时间：{{dateFormat('YYYY年mm月dd日 HH:MM', new Date(item.startTime))}} <div style="display: inline-block;margin-left:50px">结束时间：<span v-if="item.endTime">{{dateFormat('YYYY年mm月dd日 HH:MM', new Date(item.endTime))}}</span><span v-else style="color:#FF5555">未解决</span></div></div>
                                </div>
                            </div>
                            <div class="description"  style="width:50%;border-left:1px solid #CCCCCC;padding-left:20px">
                                <div class="data-title">事件诊断</div>
                                <div class="description-content">
                                    <!-- <div>告警原因：<i v-if="item.user&&item.roleId=='-9999'">演示账号</i><i v-else>{{item.user}}</i> {{item.alarm_type_desc}}</div> -->
                                    <div v-if="item.eventClassText=='操作命令'">告警原因：<i >{{item.operationUserName}}</i> {{item.alamReason}} {{item.loopName}}</div>
                                    <div v-else>告警原因：{{ item.loopName }}{{item.alamReason}} </div>
                                    <div>解决建议：{{item.suggest}}</div>
                                    <!-- <i class="grey" v-else>--</i> -->
                                    <div>告警数值：<i v-if="item.judgmentMode=='Threshold_Value'">{{item.conditionJudgmentText}}</i><i v-if="item.judgmentMode=='Threshold_Value'">{{item.maxVal.toFixed(2)}} {{item.unit}}</i><i v-else >--</i></div>
                                </div> 
                            </div>
                        </div>  
                    </div>
                </div>
                <div class="page row-center" id="page"  v-else>
                    <img src="@/assets/img/not_found_data.png" alt="">
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import PieCharts from './components/PieCharts';
import { EventCount,EventListPage,userInfo,alarmCheck} from "../../api/power";
import {dateFormat,addDay} from '../../util/DateUtil';
import dateTimeStamp from '../../util/DateDiff';
import Loading from '../../components/common/Loading.vue'
export default {
    components: { 
        PieCharts,Loading
    },
    data () {
        return {
            ClassAll:true,
            checkValue:[],
            checkList: [{
                label:"紧急",
                value:"urgent"
            },{
                label:"隐患",
                value:"hiddenDanger"
            },{
                label:"通知",
                value:"notice"
            }],
            total:0,
            eventInfo:{},
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            timeOption: [addDay(new Date(),-7),new Date()],
            eventList:[],
            page:1,
            ishow:false,
            TYPE:[{
                label:"全部类型",
                value:""
            },{
                label:"保护动作",
                value:"PROTECTIONS"
            },{
                label:"故障报警",
                value:"FAULT"
            },{
                label:"开关变位",
                value:"SWITCH_DISPLACEMENT"
            },{
                label:"越限异常",
                value:"OVERRUN"
            },{
                label:"信息通报",
                value:"MESSAGE_NOTICE"
            },{
                label:"操作命令",
                value:"OPERATION"
            },{
                label:"其他告警",
                value:"OTHER"
            }],
            identTypeClass:"", //事件分类
            IncidentClassificationClass:"",  //事件等级
            readCheckAll:true,
            readCheck:['0','1'],
            loading:true
        }
    },
    computed: {
        dateTimeStamp() {
            return dateTimeStamp
        },
        pieData: function () {
            this.total = this.eventInfo.sum
            return [{
                name: "紧急",
                value: this.eventInfo.urgent?this.eventInfo.urgent:0,
                itemStyle: {
                    color: "#FF5555"
                }
            },{
                name: "隐患",
                value: this.eventInfo.hiddenDanger?this.eventInfo.hiddenDanger:0,
                itemStyle: {
                    color: "#F5AA00"
                }
            },{
                name: "通知",
                value: this.eventInfo.notice?this.eventInfo.notice:0,
                itemStyle: {
                    color: "#0D94FF"
                }
            }]
        },
        updateData(){
            return [this.identTypeClass,this.checkValue,this.timeOption,this.readCheckAll,this.$store.state.project.currentProject.projectId]
        }
    },
    watch:{
        updateData(){
            this.getEventPage();
        },
        $route(n,o){
            if(n.query.type){
                this.checkValue = [n.query.type]
                this.readCheckAll = true
                this.ClassAll = false
                this.readCheck = ['0','1']
                this.getEventPage();
                this.timeOption = null
            }
        },
		'$store.state.project.AlarmEvent'(n, o) {
			if (n != o) {
				this.getEventCont()
                this.getEventPage();
			}
		}
    },
    mounted(){
        // this.timeOption = [addDay(new Date(),-7),new Date()]
        this.timeOption = null
        this.checkValue = this.checkList.map(e=>e.value)
        //从顶部单选类型进来
        let type = this.$route.query.type
        if(type){
            this.checkValue = [type]
            this.readCheck = ['0','1']
            this.readCheckAll = true
            this.timeOption = null
        }
        this.getEventCont()
        this.getEventPage();
    },
    methods: {
        changeReadCheckAll(state){
            this.readCheckAll = state
            if(!this.readCheckAll){
                this.readCheck = []
            }else{
                this.readCheck = ['0','1']
            }
        },
        changeClassAll(state){
            this.ClassAll = state
            if(!this.ClassAll){
                this.checkValue = []
            }else{
                this.checkValue = this.checkList.map(e=>e.value)
            }
        },
        handleReadCheck(value){
            if(value.length==2){
                this.readCheckAll = true
            }else{
                this.readCheckAll = false
            }
        },
        handleCheckedCitiesChange(value,item){
            if(value.length!=this.checkList.length){
                this.ClassAll = false
            }else{
                this.ClassAll = true
            }
        },
         checkArrow(item,index){
            let list = this.eventList.map((element,index1) => {
                if(index==index1){
                    // this.eventList.unshift(this.eventList.splice(index , 1)[0]);
                    // if(item.operation_user_id){
                    //     userInfo({uid:item.operation_user_id}).then((res) => {
                    //         let data = res.data.data.user
                    //         element.user = data.realName
                    //         element.roleId =  data.roleId
                    //         element.check = !element.check
                    //     });
                    //     // element.check = !element.check

                    // }else{
                        
                    //     element.check = !element.check
                    // }
                    element.check = !element.check
                }else{
                    element.check = false
                }
                // list.push(element)
                return element
            });
            // 已读  readCheck  0未读  1已读
            if(item.readCheck===0){
                alarmCheck([item.id])
                item.readCheck = 1
                // this.unread--
            }
            // let newlist = list
            // newlist = newlist.filter((e,i)=>i<index)
            // list.splice(0 , index)
            // this.eventList = list.concat(newlist)
            // document.getElementById('page').scrollTo(0,0)
        },
        dateFormat,
        async getEventPage(){
            this.loading = true
            // console.log(this.timeOption,"this.timeOption")
            let end = this.timeOption?dateFormat('YYYY/mm/dd', new Date(this.timeOption[1])):""
            let obj = {
                projectId: this.$store.getters.projectId,
                page:1,
                size:1000,
                incidentClassificationClass:this.checkValue.join(','),
                identTypeClass:this.identTypeClass,
                start:this.timeOption?dateFormat('YYYY/mm/dd', new Date(this.timeOption[0])):"",
                end:end,
                solveFlag:this.readCheckAll?"":this.readCheck.toString()
                // alarmCheck:this.readCheckAll?"":this.readCheck.toString()
            }
            if(obj.start==obj.end&&obj.end!=""){
                obj.end = dateFormat('YYYY/mm/dd',addDay(new Date(this.timeOption[1]),1))
            }
            
            let result = await EventListPage(obj);
            let data = result.data.data.eventList
            
            if(data.records.length>0){
                let news = []
                data.records.forEach(element => {
                    element.check = false
                    if(element.operation_user_id){
                        // userInfo({uid:element.operation_user_id}).then((res) => {
                        //     let data = res.data.data.user
                        //     element.user = data.realName
                        //     element.roleId =  data.roleId
                        // });
                        news.push(element)
                    }else{
                        news.push(element)
                    }
                });
                let self = this
                // if(news[0].operation_user_id){
                //     userInfo({uid:news[0].operation_user_id}).then((res) => {
                //         let data = res.data.data.user
                //         news[0].user = data.realName
                //         news[0].roleId =  data.roleId
                //     });
                // }
                setTimeout(function(){
                    self.eventList = news.map(e=>{e.check= false; return e})
                    // .filter(e=>e.roleId!='-9999')
                    self.eventList[0].check = true
                    
                    // if(self.readCheckAll){ //全选

                    // }else{
                    //     self.eventList = self.eventList.filter(e=>{
                    //         if(self.readCheck.toString()==0){
                    //             if(!e.endTime){
                    //                 return e
                    //             }
                    //         }else{
                    //             if(e.endTime){
                    //                 return e
                    //             }
                    //         }
                            
                    //     })
                    // }
                    self.ishow = false
                    self.loading = false
                    
                    if(self.eventList.length==0){
                        self.ishow = true
                    }
                },1000)
                
                
            }else{
                this.ishow = true
                this.loading = false
                this.eventList = []
            }
        },
        async getEventCont(){
            let result = await EventCount({
                projectId: this.$store.getters.projectId,
            });
            let data = result.data.data.eventNum.all
            this.eventInfo = data
        },
    }
}
</script>

<style lang="less" scoped>
.EventManagement{
    background: #ffffff;
    height: 100%;
    width: 100%;
    .p-title{
        font-size: 18rem;
        font-weight: bold;
        height: 45rem;
        line-height: 45rem;
        padding-left: 20rem;
    }
    .land{
        // padding: 0 24px;
        height: 220rem;
        justify-content: space-around;
        .pie{
            width: 160rem;
            height: 100%;
        }
        .panelright{
            // justify-content: space-between;
            // flex-flow: column;
            width: 80%;
            .item{
                .w(308);
                .h(120);
                background: rgba(13, 148, 255, 0.04);
                border-radius: 8rem;
                text-align: center;
                
                .name{
                    font-size: 24rem;
                    // margin-top: 30px;
                }
                .num{
                    font-size: 32rem;
                    font-weight: bold;
                    margin-top: 5px;
                }
            }
        }
    }
    .title{
        font-size: 18rem;
        font-weight: 700;
        color: #fff;
        line-height: 40rem;
        padding-left: 20rem;
        background: linear-gradient(90deg,#002b66,#81add7 50%,rgba(13,148,255,0));
    }
    .eventPage{
        padding:0 20px;
        .search{
            height: 70px;
            align-content: flex-start;
            .block{
                margin-right: 10px;
            }
            .el-range-editor.el-input__inner{
                border-radius: 20px
            }
            .el-button{
                border-radius: 20px
            }
            /deep/.el-input__inner{
                border-radius: 20px
            }
        }
        .page{
            .h(530);
            overflow: auto;
        }
        .cont{
            border: 1px solid #ffffff;
            border-radius: 4px;
            margin-bottom: 20rem;
            // height: 350px;
            .header{
                overflow: hidden;
                cursor: pointer;
                .type{
                    width: 72rem;
                    .h(72);
                    background: #F23F36;
                    border-radius: 4px;
                    color: #ffffff;
                    font-size: 18rem;
                    font-weight: bold;
                    text-align: center;
                    padding: 5px 0;
                    float: left;
                    position: relative;
                    img{
                        display: inline-block;
                        width:27rem;
                    }
                    i{
                        display: block;
                        width: 100%;
                    }
                    
                    .point{
                        position: absolute;
                        right: -3px;
                        top: 0px;
                        width: 9px;
                        height: 9px;
                        border-radius: 50%;
                        overflow: hidden;
                        background-color: rgba(253, 66, 56, 1);
                        box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.302);
                    }
                }
                .name-r{
                    width: calc(100% - 90rem);
                    .h(72);
                    background: rgba(242, 63, 54, 0.1);
                    border-radius: 4px;
                    float: right;
                    padding: 2px 10px 0 20px;
                    align-content: space-between;
                    .left{
                        height:100%
                    }
                    .name{
                        font-size: 20rem;
                        font-weight: bold;
                    }
                    .text{
                        font-size: 18rem;
                        font-weight: 600;
                        color: #666666;
                    }
                    .time{
                        font-size: 14rem;
                        font-weight: 400;
                        color: #666666;
                    }
                    .arrow{
                        margin-left: 20px;
                        cursor: pointer;
                        i{
                            font-size: 28px;
                            color: #666666;
                            // font-weight: bold;
                        }
                    }
                }
            }
            .yell{
                .type{
                    background: #F6BD16;
                }
                .name-r{
                    background: rgba(246, 189, 22, 0.1);
                }
            }
            .notice{
                .type{
                    background: #0D94FF;
                }
                .name-r{
                    background: rgba(13, 148, 255, 0.1);
                }
            }
            .info{
                padding:10px 20px;
                display: none;
                // .h(164);
                min-height: 15.185vh;
                .description {
                    // margin-top: 20px;
                    // width: 50%;
                    .data-title{
                        font-size: 16rem;
                        // font-weight: bold;
                        line-height: 19px;
                        margin: 5px 0;
                        &::before{
                            content: '';
                            width: 4px;
                            height: 19rem;
                            background: #0D94FF;  
                            display: inline-block;
                            vertical-align: -2px;
                            margin-right: 8px;
                        }
                    }
                    .description-content {
                        display: flex;
                        flex-flow: column nowrap;
                        div {
                            font-size: 16rem;
                            font-weight: 400;
                            line-height: 27rem;
                            padding-left: 12px;
                            // color: #666666;
                            // margin-bottom: 14rem;
                        }
                    }
                }
            }
        }
        .show{
            border: 1px solid #CCCCCC;
            .info{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
            }
            .el-icon-arrow-right{
                transform-origin: center center;
                transform: rotate(90deg);
                // transition: all .5s ease-in .1s;
            }
        }
        
    }
}
    
.dropdownList{
    width: 120px;
    // padding:0;
    .el-checkbox{
        display: block;
        line-height: 30px;
        margin: 0;
        padding: 0 20px;
    }
    
    .all{
        // padding: 5px 0 5px 20px;
        border-bottom: 1px solid #E5E5E5;
        margin-bottom: 5px;
    }
    .checkbox{
        // padding: 10px 0 0 20px;
    }
}
	
</style>